import React, { ReactNode } from 'react';
import { LazyImage } from '../../wag-react/components/lazyload/LazyImage';
import { Box } from '../../wag-react/next-components/box';
import { Typography } from '../Typography';
export type PersonDetailsCardProps = {
  name: string;
  preName?: string;
  postName?: ReactNode;
  image: string;
  bio?: string;
  preBio?: ReactNode;
};
export const PersonDetailsCard = ({
  name,
  preName,
  postName,
  image,
  bio,
  preBio
}: PersonDetailsCardProps) => <Box display="grid" gridTemplateColumns="50px 1fr" gridGap="12px" alignItems="center" data-sentry-element="Box" data-sentry-component="PersonDetailsCard" data-sentry-source-file="PersonDetailsCard.tsx">
    <Box height="50px" data-sentry-element="Box" data-sentry-source-file="PersonDetailsCard.tsx">
      {!!image && <LazyImage src={image} width="50px" height="50px" borderRadius="50px" imageProps={{
      borderRadius: '50px'
    }} />}
    </Box>
    <Box data-sentry-element="Box" data-sentry-source-file="PersonDetailsCard.tsx">
      {!!name && <Box display="flex" alignItems="center" mb={bio ? '7px' : '0px'}>
          <Typography variant="body2" display="block" lineHeight="1.5" mt="0">
            {preName}
            {' '}
            <Box as={'b'} style={{
          textTransform: 'capitalize',
          whiteSpace: 'nowrap'
        }}>
              {name}
              {!!postName && postName}
            </Box>

          </Typography>

        </Box>}
      {!!bio && <Box display="flex" alignItems="center">
          {!!preBio && preBio}
          <Typography variant="legal" display="block" lineHeight="1.5" my="0" opacity={0.5}>
            {bio}
          </Typography>
        </Box>}

    </Box>
  </Box>;